import api from '../../../../app/ApiConfig';
import { Apis } from '../../../../config';
import { NotificationManager } from 'react-notifications';


// Get all addresses for a customer by customer ID
const getAddressesByCustomerId = async (custId) => {
    try {
        let result = await api.get(`${Apis.GetAddressesByCustomerId}?custId=${custId}`);
        if (result.data.error) {
            NotificationManager.error(result.data.error);
            return null;
        }
        return result.data;
    } catch (error) {
        console.error(error);
        NotificationManager.error('An error occurred while fetching addresses.');
        return null;
    }
};


export default {
    getAddressesByCustomerId,
};
